export const LOAD_DAILYTEXTS = "LOAD_DAILYTEXTS";
export const LOAD_DAILYTEXTS_SUCCESS = "LOAD_DAILYTEXTS_SUCCESS";
export const LOAD_DAILYTEXTS_ERROR = "LOAD_DAILYTEXTS_ERROR";
export const SAVE_DAILYTEXTS = "SAVE_DAILYTEXTS";
export const SAVE_DAILYTEXTS_SUCCESS = "SAVE_DAILYTEXTS_SUCCESS";
export const SAVE_DAILYTEXTS_ERROR = "SAVE_DAILYTEXTS_ERROR";



// WEBPACK FOOTER //
// ./src/store/actions/dailytexts.js